export type GroupedByYearMonth<T> = Record<number, Record<number, T[]>>;

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/** Bucket items into year -> month (0-based) -> items. */
export function groupByYearAndMonth<T>(
  items: T[],
  getDate: (item: T) => string | Date,
): GroupedByYearMonth<T> {
  const grouped: GroupedByYearMonth<T> = {};

  items.forEach((item) => {
    const date = new Date(getDate(item));
    if (Number.isNaN(date.getTime())) return;

    const year = date.getFullYear();
    const month = date.getMonth();

    if (!grouped[year]) {
      grouped[year] = {};
    }
    if (!grouped[year][month]) {
      grouped[year][month] = [];
    }
    grouped[year][month].push(item);
  });

  return grouped;
}

/** Years present in the grouping, newest first. */
export function sortedYears<T>(grouped: GroupedByYearMonth<T>): number[] {
  return Object.keys(grouped)
    .map(Number)
    .sort((a, b) => b - a);
}

export function countItemsInYear<T>(
  grouped: GroupedByYearMonth<T>,
  year: number,
): number {
  const yearData = grouped[year];
  if (!yearData) return 0;
  return Object.values(yearData).reduce(
    (sum, monthItems) => sum + monthItems.length,
    0,
  );
}
